import React from "react";
import { Row, Col, Modal, Select, Button } from 'antd';
import { MdOutlineClose } from "react-icons/md";
import NumberFormat from 'react-number-format';
import TimePeriods from '../constants/timePeriods';
import TimeUnits from '../constants/timeUnits';

const InvoicePaymentReminderModal = props => {

  const { isVisible, setVisible = () => {}, title = "", selectedReminder = {}, setSelectedReminder = () => {}, submit = () => {}, reminderError } = props;

  return (
    <Modal visible={isVisible} footer={null} onCancel={() => setVisible(false)} width={500} closable={false} maskClosable={false} wrapClassName="rounded-modal">
      <Row align="middle">
        <Col flex={1}>
          <div className="fw-700 fs-18">{title}</div>
        </Col>
        <Col>
          <div className="display-flex" onClick={() => setVisible(false)}><MdOutlineClose size={30} color={"#CCC"}/></div>
        </Col>
      </Row>
      <Row className="mt-20">
        <Col xs={24}>
          <div className="mb-10 c-text-gray">When would you like this reminder to be sent?</div>
        </Col>
        <Col flex={0}>
          <NumberFormat 
            className="ant-input ant-input-lg" 
            displayType={'input'} 
            thousandSeparator={true} 
            style={{ width: 60 }}
            decimalScale={0} 
            placeholder={"#"}
            value={selectedReminder.time_value} 
            onChange={(e) => setSelectedReminder({ ...selectedReminder, time_value: e.target.value})}
          />
        </Col>
        <Col flex={0}>
          <Select
            style={{ width: 100 }}
            placeholder={"Select"}
            size='large'
            value={selectedReminder.time_unit}
            onChange={(value) => setSelectedReminder({ ...selectedReminder, time_unit: value})}
          >
            <Select.Option value={TimeUnits.DAYS}>days</Select.Option>
            <Select.Option value={TimeUnits.WEEKS}>weeks</Select.Option>
          </Select>
        </Col>
        <Col flex={1}>
          <Select
            style={{ width: '100%' }}
            placeholder={"Select"}
            size='large'
            value={selectedReminder.time_period}
            onChange={(value) => setSelectedReminder({ ...selectedReminder, time_period: value})}
          >
            <Select.Option value={TimePeriods.BEFORE}>before due date</Select.Option>
            <Select.Option value={TimePeriods.AFTER}>after due date</Select.Option>
          </Select>
        </Col>
      </Row>
      <Row gutter={[10,10]} className="mt-20">
        <Col xs={24}>
          <div className="bg-gray p-10 fs-12"><span className="fw-700">Tip:</span> If you would like the send a reminder on the due date, enter "0 days before due date".</div>
        </Col>
        <Col xs={24}>
          <div className="fs-12 c-red text-center">{ reminderError }</div>
        </Col>
        <Col xs={24}>
          <div className="mt-20 text-right">
            <Button className="admin-small-button secondary" onClick={() => setVisible(false)}>Cancel</Button>
            <Button className="admin-small-button ml-10" onClick={submit}>
              Save
            </Button>
          </div>
        </Col>
      </Row>
    </Modal>
  )
};

export default InvoicePaymentReminderModal;
